import { RemoteSumpAnimatic } from '@crossnokaye/ux-animatics';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/constants';
import { getLabel } from '@/features/equipment-browser/animatics/helpers';
import { convertPercentToDecimal, getRefValue } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticRemoteSump = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const flip = config.specificAnimaticConfig?.remoteSump?.flip ?? false;
  const levelRef = config.specificAnimaticConfig?.remoteSump?.levelRef;
  const level = levelRef ? convertPercentToDecimal(getRefValue(levelRef)) : undefined;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <RemoteSumpAnimatic flip={flip} label={primaryLabel?.text} state={state} value={level} />
    </ScaledAnimatic>
  );
};
